export const OPERACAO_SUCESSAO = [
  {
    "operacoesPorSucedida": [
      {
        "cnpj": "08832031000463",
        "razaoSocial": "",
        "dataOperacao": [
          2020,
          2,
          3
        ],
        "operacao": {
          "codigo": "227",
          "descricao": "Cisão parcial (específico para a sucessora)"
        }
      }
    ],
    "operacoesPorSucessora": []
  }
]